import { supabase } from '../supabaseClient'

/** Em localhost o CRA usa proxy (/api/...) para evitar falha de CORS nas Edge Functions. */
export const USE_DEV_EDGE_PROXY =
  process.env.NODE_ENV === 'development' &&
  typeof window !== 'undefined' &&
  /^https?:\/\/localhost(:\d+)?$/i.test(window.location.origin)

const DEV_PROXY_PATHS = {
  'whatsapp-crm-send': '/api/whatsapp-crm-send',
  'whatsapp-send-message': '/api/whatsapp-send-message',
  'whatsapp-list-templates': '/api/whatsapp-list-templates',
  'whatsapp-media': '/api/whatsapp-media',
  'google-calendar': '/api/google-calendar',
  'goodwe-monitoramento': '/api/goodwe-monitoramento',
  'solplanet-monitoramento': '/api/solplanet-monitoramento',
  'monitoramento-credenciais': '/api/monitoramento-credenciais',
  'monitoramento-notificacoes': '/api/monitoramento-notificacoes'
}

/**
 * Invoca Edge Function direto (produção) ou via proxy local (dev).
 */
export async function invokeEdgeFunction(functionSlug, body) {
  const proxyPath = USE_DEV_EDGE_PROXY ? DEV_PROXY_PATHS[functionSlug] : null

  if (proxyPath) {
    const res = await fetch(proxyPath, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body ?? {})
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      const message =
        (typeof data?.error === 'string' && data.error) ||
        data?.message ||
        `HTTP ${res.status}`
      return {
        data,
        error: {
          message,
          context: { json: async () => data }
        }
      }
    }
    return { data, error: null }
  }

  return supabase.functions.invoke(functionSlug, { body })
}

/** Extrai mensagem legível de erro da Edge Function (SDK ou proxy). */
export async function extrairErroEdgeFunction(error, data) {
  if (data?.error) {
    return typeof data.error === 'string' ? data.error : String(data.error)
  }
  if (data?.success === false && data?.error) {
    return String(data.error)
  }
  try {
    if (error?.context && typeof error.context.json === 'function') {
      const body = await error.context.json()
      if (body?.error) return typeof body.error === 'string' ? body.error : String(body.error)
    }
  } catch (_) {
    /* ignore */
  }
  const msg = error?.message || ''
  if (msg.includes('Failed to send a request to the Edge Function')) {
    return 'Não foi possível contactar a Edge Function. Em dev, reinicie o npm start após alterações no proxy; em produção, verifique o deploy da função no Supabase.'
  }
  if (msg && !msg.includes('non-2xx')) return msg
  return 'Falha na Edge Function. Verifique o deploy e os secrets no Supabase.'
}
